import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AnimatePresence, motion } from 'framer-motion';
import { contextsColors } from '../config';

const colors = ['0d3847', '621333', '9c2348', 'a6802d', 'e7d295', 'e6e6e6'] ;

export default function Row({ depth, id, clave, title, description = '', context }) {
    const [visibleDescription, setVisibleDescription] = useState(false);

    const hasDescription = description.length > 0;

    const toggleVisibleDescription = () => {
        if(description.length > 0) setVisibleDescription(!visibleDescription);
    }

    let imgArrowClassName = 'rotated';
    if(!visibleDescription) imgArrowClassName = '';

    let ctxtColor = `#${ colors[depth - 1] }`;
    if(context > 0){
        ctxtColor = `#${ contextsColors[(context - 1) % 4] }`;
    }

    const fontColor = (depth > colors.length - 2 ? 'black' : 'white');

    return (
        <AnimatePresence>
            <tr id={ `${ depth }-${ id }` }>
                {
                    colors.map((color, index) => {
                        const colorIndexDepth = (index < depth ? index : (depth - 1));
                        const style = { 
                            backgroundColor: `#${colors[ depth > 1 && index === 0 ? 1 : colorIndexDepth ]}`
                        };

                        return <motion.td 
                            key={ `${ depth }-${ id }-format${index}` } 
                            layout 
                            rowSpan="2"
                            style={ style }
                        ></motion.td>
                    })
                }
                
                <motion.td
                    key={ `${ depth }-${ id }-clave` }
                    layout
                    className='title-cell'
                    style={{ backgroundColor: `#${colors[ depth - 1 ]}`, color: fontColor }}
                    >
                        { clave }
                </motion.td>
                
                <motion.td
                    key={ `${ depth }-${ id }-context` }
                    layout
                    rowSpan="2"
                    className='flag-context-cell'
                    style={{ backgroundColor: `#${colors[ depth - 1 ]}` }}
                > <center>
                    <div className='flag-context-div' style={{ backgroundColor: ctxtColor }}>
                        <span className={ `content-cell ${(depth > colors.length - 2 ? 'text-small' : '')}` }>
                            
                        </span>
                    </div> </center>
                </motion.td>

                <td key={ `${ depth }-${ id }-title` }
                    onClick={ toggleVisibleDescription }
                    className={ `content-cell ${(depth > colors.length - 2 ? 'text-small' : '')}` }
                    style={{ 
                        backgroundColor: `#${colors[ depth - 1 ]}`,
                        color: fontColor
                    }}
                >
                    <div className='horizontal-content title-container'>
                        <div style={{ 
                            width: '90%',
                            color: fontColor
                        }}>{ title }</div>
                        <div style={{ 
                            flexDirection: 'row-reverse'
                        }} className={imgArrowClassName}>{ hasDescription ? 
                            <span className={`icon-caret-down`} aria-hidden="true" 
                                style={{color: fontColor}}></span> : 
                            '' }
                        </div>
                    </div>
                </td>
            </tr>
            {
                visibleDescription ? 
                    <motion.tr 
                        key={ `${ depth }-${ id }-tr-desc` }
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        >
                        <motion.td
                            key={ `${ depth }-${ id }-td-desc-fill` }
                            className='title-cell'
                            style={{ 
                                backgroundColor: `#${colors[ depth - 1 ]}`,
                                color: fontColor
                            }}
                            >
                        </motion.td>
                        <motion.td 
                            key={ `${ depth }-${ id }-td-desc` }
                            // style={{ backgroundColor: `#${desColors[ depth - 1 ]}` }}
                            style={{ 
                                backgroundColor: `#${colors[ depth - 1 ]}`,
                                color: fontColor
                            }}
                            className='content-cell text-very-small description-cell'
                        >{ description }</motion.td>
                    </motion.tr> : <motion.tr key={ `${ depth }-${ id }-tr-des` }></motion.tr>
            }
        </AnimatePresence>
    )
}

Row.propTypes = {
    depth: PropTypes.number.isRequired,
    id: PropTypes.number.isRequired,
    clave: PropTypes.string,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    context: PropTypes.number,
};
